import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { HsgRouteGuardService } from '@hhsg/hsg-asc';

import { WorkforceRouteGuardService } from '../../../workforce-route-guard.service';
import { CostCenterMappingComponent } from './cost-center-mapping/cost-center-mapping.component';
import { ImportComponent } from './import.component';
import { JobTitleMappingComponent } from './job-title-mapping/job-title-mapping.component';
import { TimePayCodeMappingComponent } from './time-pay-code-mapping/time-pay-code-mapping.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path: '',
				component: ImportComponent,
				children: [
					{ path: 'cost-center-mapping', component: CostCenterMappingComponent, canActivate: [ HsgRouteGuardService, WorkforceRouteGuardService ] },
					{ path: 'job-title-mapping', component: JobTitleMappingComponent, canActivate: [ HsgRouteGuardService, WorkforceRouteGuardService ] },
					{ path: 'time-pay-code-mapping', component: TimePayCodeMappingComponent, canActivate: [ HsgRouteGuardService, WorkforceRouteGuardService ] }					
				]
			}
		])
	],
	exports: [RouterModule]
})
export class ImportRoutingModule {
}
